import { isNullOrUndefinedOrEmpty, PEV } from "../../../common/utils";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as service from "./service";

const initialState = {
  applicationList: PEV(
    {
      data: [],
      currentReviewCycleStartDate: null,
    },
    "not loaded",
  ),
  appLatestReviewFiles: PEV({}, "not loaded"),
};

export const allApplicationsTab = { id: "allApplications", name: "Applications" };
export const allApplicationsTable = { id: "allApplicationsTable" };

const getApplicationList = createAsyncThunk("applicationList/fetch", async () => {
  return await service.fetchAppList();
});

const submitFileVerification = createAsyncThunk("applicationReviewFilesVerification", async (param) => {
  return await service.submitFileVerification(param.appId, param.isAccepted, param.comment);
});

const startNewReview = createAsyncThunk("applicationReviewNewRound", async (appId) => {
  return await service.startNewReview(appId);
});

const ApplicationListPageSlice = createSlice({
  name: "applicationList",
  initialState,
  reducers: {
    updateAppStatusOnReviewHistoryChange(state, action) {
      const { appId, inProgressReview, lastClosedReview } = action.payload;
      const appList = state.applicationList?.value?.data;
      const appIndex = appList?.findIndex((app) => app.id === appId);
      if (appIndex >= 0) {
        const recentReviews = appList[appIndex].recentReviews;
        if (isNullOrUndefinedOrEmpty(recentReviews)) {
          appList[appIndex].recentReviews = {};
        }
        recentReviews.inProgressReview = {
          ...recentReviews.inProgressReview,
          ...inProgressReview,
        };
        recentReviews.lastClosedReview = {
          ...recentReviews.lastClosedReview,
          ...lastClosedReview,
        };
      }
    },
    resetApplicationList(state) {
      state.applicationList = initialState.applicationList;
    },
    uploadFileSubmit(state, action) {
      updateAppStatusActions(state, action.payload.appId, action.payload);
    },
    updateAppAccessTypeLink(state, action) {
      const appIndex = state.applicationList.value.data.findIndex(x => x.id === action.payload.appId);
      state.applicationList.value.data[appIndex].accessTypeLink = action.payload.accessTypeLink;
    },
  },
  extraReducers: {
    [getApplicationList.pending.type]: (state) => {
      state.applicationList = PEV({ ...state.applicationList }, "Fetching applications");
    },
    [getApplicationList.fulfilled.type]: (state, action) => {
      state.applicationList = PEV({
        data: action.payload.appsList,
        currentReviewCycleStartDate: action.payload.currentReviewCycleStartDate,
      });
    },
    [getApplicationList.rejected.type]: (state) => {
      state.applicationList = PEV(
        { ...state.applicationList },
        null,
        "Error while fetching applications",
      );
    },
    [submitFileVerification.fulfilled.type]: (state, action) => {
      updateAppStatusActions(state, action.meta.arg.appId, action.payload);
    },
    [startNewReview.fulfilled.type]: (state, action) => {
      updateAppStatusActions(state, action.meta.arg, action.payload);
    },
  },
});

function updateAppStatusActions(state, appId, payload) {
  const appIndex = state.applicationList.value.data.findIndex(x => x.id === appId);
  if (appIndex >= 0) {
    state.applicationList.value.data[appIndex].currentStatus = payload.currentStatus;
    state.applicationList.value.data[appIndex].applicableActions = payload.applicableActions;
  }
}

export const ApplicationListPageReducer = ApplicationListPageSlice.reducer;
const {
  updateAppStatusOnReviewHistoryChange,
  resetApplicationList,
  uploadFileSubmit,
  updateAppAccessTypeLink,
} = ApplicationListPageSlice.actions;
export const ApplicationListPageActions = {
  getApplications: getApplicationList,
  fetchAppsIfNotPresent: () => (dispatch, getState) => {
    const state = getState();
    if (!state.applicationList.value || state.applicationList.value.data.isEmpty()) {
      dispatch(getApplicationList());
    }
  },
  updateAppStatusOnReviewHistoryChange,
  resetApplicationList,
  uploadFileSubmit,
  submitFileVerification,
  startNewReview,
  updateAppAccessTypeLink,
};

export const ApplicationInReviewStatus = "In Progress";
export const ReviewVerificationPending = "Closed & Verification Pending";
export const ApplicationNotInReviewStatus = "Not Started";
export const complianceTags = { all: "All", itgc: "ITGC", others: "Others", sso: "SSO" };
export const selectComplianceTagKey = "appComplianceTagFilter";
